import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { queryClient } from './api/queryClient';
import { AuthProvider } from './context/AuthContext';
import { MapProvider } from './context/MapContext';
import { ProjectProvider } from './context/ProjectContext';
import { router } from './routes/routes';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import { FilterProvider } from './context/FilterContext';
import { CookieConsent } from '@/components';
import { TableCalculationsProvider } from './context/TableCalculationsContext';
//import DevTools from './components/DevTools';


//REMOVES GOOGLE DEPRICATED WARNINGS
const originalWarn = console.warn;

// Override console.warn
console.warn = function(message, ...args) {
  // List of warnings you want to ignore
  const ignoredWarnings = [
    'As of March 1st, 2025',
  ];

  // Check if the message is in the ignored list
  if (!ignoredWarnings.some(ignored => message.includes(ignored))) {
    // Call the original console.warn if not ignored
    originalWarn.apply(console, [message, ...args]);
  }
};

function App() {
  return (
    <>
      <AuthProvider>
      <CookieConsent/>
        <ProjectProvider>
          <FilterProvider>
            <MapProvider>
              <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={theme}>
                 <TableCalculationsProvider>
                    <GlobalStyles />
                    <RouterProvider router={router} />
                 </TableCalculationsProvider>
                </ThemeProvider>
              </QueryClientProvider>
            </MapProvider>
          </FilterProvider>
        </ProjectProvider>
      </AuthProvider>
    </>
  );
}

export default App;
